let blurCount = 0;

export function enableModalBlur() {
  blurCount += 1;
  document.body.classList.add("modal-blur-backdrop");
}

export function disableModalBlur() {
  blurCount = Math.max(0, blurCount - 1);
  if (blurCount === 0) {
    document.body.classList.remove("modal-blur-backdrop");
  }
}
